import {
  Action,
  ActionType,
  IAutoReleaseResponse,
} from "models/contract/autoRelease";
import { IResponse } from "models";
import createReducer from "../../createReducer";

export interface AutoReleaseType {
  loading: boolean;
  error?: string;
  autoReleaseResponse?: IAutoReleaseResponse;
}

const defaultState: AutoReleaseType = {
  loading: false,
  error: undefined,
  autoReleaseResponse: undefined,
};

export const autoReleaseReducer = createReducer<AutoReleaseType>(defaultState, {
  [ActionType.CONTRACT_INFORMATION_AUTO_RELEASE](state: AutoReleaseType) {
    return {
      ...state,
      loading: true,
    };
  },

  [ActionType.CONTRACT_INFORMATION_AUTO_RELEASE_ERROR](
    state: AutoReleaseType,
    action: Action<number>
  ) {
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
  },

  [ActionType.CONTRACT_INFORMATION_AUTO_RELEASE_SUCCESS](
    state: AutoReleaseType,
    action: Action<number>
  ) {
    return {
      ...state,
      loading: false,
      error: null,
      autoReleaseResponse: action.payload,
    };
  },

  [ActionType.CONTRACT_INFORMATION_AUTO_RELEASE_RESET](state: AutoReleaseType) {
    return {
      ...state,
      loading: false,
      error: null,
      autoReleaseResponse: undefined,
    };
  },
});
